import React, { Component } from 'react';
import { AdvisoryHeader, Block, Button, Loader } from 'components';
import SystemInfoModal from 'views/systems/info-modal/container';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { browserHistory } from 'react-router';

// Hardcoded project creation settings
const PROJECT_DUE_DATE = new Date();
const PROJECT_STATUS = 'concept';
const PROJECT_TYPE = 'new';

export default class AdvisoryToolResultView extends Component {

  /* Lifecycle */

  constructor() {
    super();

    this.state = {
      loading: true,
      buffervatSize: null,
    };

    this.handleQuoteRequest = this.handleQuoteRequest.bind(this);
    this.handleSystemClick = this.handleSystemClick.bind(this);
  }

  componentWillMount() {
    if (this.props.advisory.criteria.system && Object.keys(this.props.advisory.criteria.system).length) {
      if (this.props.advisory.criteria.buffer && Object.keys(this.props.advisory.criteria.buffer).length && this.props.advisory.criteria.system.heat_pump_energy === 'all electric') {
        this.props.systemsCalculateBuffer(this.props.advisory.criteria.buffer).then((response) => {
          this.setState({ buffervatSize: response.liters });
          this.determine(response);
        });
      } else {
        this.determine();
      }
    } else {
      browserHistory.push('/advisory-tool/');
    }
  }

  /* Methods */

  determine(buffer = {}) {
    this.props.systemsDetermine({ ...this.props.advisory.criteria.system, ...buffer }).then(() => {
      this.setState({ loading: false });
    }).catch(() => {
      browserHistory.push('/advisory-tool/40');
    });
  }

  /* Handlers */

  handleQuoteRequest() {
    this.setState({ loading: true });

    const system = this.props.systems.determine.data;

    const projectPayload = {
      data: {
        attributes: {
          due_date: PROJECT_DUE_DATE,
          name: system.attributes.product_names[this.props.intl.locale],
          status: PROJECT_STATUS,
          type: PROJECT_TYPE,
        },
      },
    };

    this.props.projectsCreate(projectPayload).then((response) => {
      const systemPayload = {
        data: {
          id: response.id,
          relationships: {
            original_system: {
              data: {
                id: system.id,
                type: 'System',
              },
            },
          },
        },
      };

      this.props.projectSetSystem(systemPayload).then(() => {
        browserHistory.push(`/systems/${response.id}`);
      });
    });
  }

  handleSystemClick() {
    const system = this.props.systems.determine.data;

    this.props.appModalOpen({
      component: (
        <SystemInfoModal
          onSubmit={this.props.appModalClose}
          system={system}
        />
      ),
      price: system.attributes.price,
      scrollDisabled: true,
      title: system.attributes.name,
      type: 'large',
    });
  }

  /* Render */

  renderTitle() {
    if (this.state.buffervatSize) {
      return <FormattedMessage id={'advisory.result.titleBuffer'} values={{ liter: this.state.buffervatSize }} />;
    }

    return <FormattedMessage id={'advisory.result.title'} />;
  }

  renderResult() {
    const system = this.props.systems.determine.data;

    if (this.props.systems.determine.get.loading || !system || this.state.loading) {
      return (
        <Loader size="lg" />
      );
    }

    const systemAttributes = system.attributes;

    return (
      <div>
        <div className="advisory-result__title">
          {this.renderTitle()}
        </div>
        <Block
          item={systemAttributes}
          price={systemAttributes.price}
          subtitle={systemAttributes.brand}
          schema={systemAttributes.image || systemAttributes.sketch}
          title={systemAttributes.name}
          onClick={this.handleSystemClick}
        />
      </div>
    );
  }

  renderQuoteButton() {
    if (this.props.systems.determine.data && !this.state.loading) {
      return (
        <Button
          className="button button-bg-yellow button-full-width button-full-width--with-sidebar"
          text="advisory.result.quote"
          onClick={this.handleQuoteRequest}
        />
      );
    }

    return null;
  }

  render() {
    return (
      <div className="view">
        <AdvisoryHeader />
        <div className="view__content">
          <div className="advisory-result__system">
            <div className="align align--full-height align--fluid">
              <div className="align__cell">
                {this.renderResult()}
              </div>
            </div>
            {this.renderQuoteButton()}
          </div>
        </div>
      </div>
    );
  }
}

AdvisoryToolResultView.propTypes = {
  advisory: PropTypes.object,
  appModalClose: PropTypes.func,
  appModalOpen: PropTypes.func,
  intl: PropTypes.object,
  projectsCreate: PropTypes.func,
  projectSetSystem: PropTypes.func,
  systems: PropTypes.object,
  systemsCalculateBuffer: PropTypes.func,
  systemsDetermine: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/views/advisory-tool/result/index.jsx